module.exports = __webpack_public_path__ + "img/about-icon-3.3f988f91.svg";